
import { defineComponent, computed } from 'vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Button from '@/components/elements/Button.vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'ToRegisterEvent',
  components: {
    HeadingLv3,
    Button
  },
  setup() {
    const route = useRoute()
    const registerPath = computed(() => {
      const base = '/register/events/user_category'
      return `${base}?event_id=${route.params.id}`
    })

    return {
      registerPath
    }
  }
})
